import React from "react";
import { useAuth } from "shared/context/auth";
import { MyExpRoute } from "apps/myExperience/routes/types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetParticipantListForManagement } from "./dataloader";
import { ManageOrgAdminService } from "./types";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";

export default function useManageOrgAdminService(): ManageOrgAdminService {
  const { userDetail } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useLogAnalyticsScreenHook({ properties: { screenType: AnalyticsScreenNameEnum.MANAGE_ORGANIZATION_ADMIN } });

  const { data: participantList = [], refetch } = useGetParticipantListForManagement({
    regParticipantId: userDetail?.id
  });

  const closeManageOrgAdminHandler = React.useCallback(() => {
    navigate({
      pathname: MyExpRoute.HOME.path,
      search: searchParams.toString()
    });
  }, [navigate, searchParams]);

  const createOrgAdminHandler = React.useCallback(() => {
    navigate({
      pathname: MyExpRoute.MANAGE_ORG_ADMIN.create.path,
      search: searchParams.toString()
    });
  }, [navigate, searchParams]);

  return {
    refetch,
    participantList,
    createOrgAdminHandler,
    closeManageOrgAdminHandler
  };
}
